// Module
var code = "<div class=\"gc-fake-step\">Ishaan</div>";
// Exports
export default code;